import { render } from "./ContactListPage.vue?vue&type=template&id=39aee43f&scoped=true"
import script from "./ContactListPage.vue?vue&type=script&lang=js"
export * from "./ContactListPage.vue?vue&type=script&lang=js"

import "./ContactListPage.vue?vue&type=style&index=0&id=39aee43f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39aee43f"

export default script